import { Component, OnInit, HostListener } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'scroll-to-top-btn',
  templateUrl: './scroll-to-top-btn.component.html',
  styleUrls: ['./scroll-to-top-btn.component.css'],
  animations: [
    trigger('scrollButton', [
      state('in', style({
        'display': 'block'
      })),
      state('out', style({
        'display': 'none'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ])
  ]
})
export class ScrollToTopBtnComponent implements OnInit {
  animationState: string = "out";
  scrollDistance: number = 200;

  constructor() { }

  ngOnInit(): void {
  }

  /* Fade in or out scroll to top button */
  @HostListener('window: scroll', [])
  onWindowScroll() {
    this.animationState = this.getCurrentScrollTop() > this.scrollDistance ? 'in' : 'out';
  }

  scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  getCurrentScrollTop() {
    if (typeof window.scrollY !== 'undefined' && window.scrollY >= 0) {
      return window.scrollY;
    }
    return 0;
  };

}
